// Mirrors admin-login.jsx, but posts a garage code + password to
// /api/garage-auth/login instead of the superadmin /api/auth/login.
// Reuses the same admin-login.css classes for visual consistency
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginGarage } from "../api/garageAuth";
import Navigation from "../components/garage/navigation";
import logo from "../assets/logo.png";
import "../styles/admin-login.css";

export default function GarageLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await loginGarage(code.trim(), password);
      navigate(location.state?.from || "/garage", { replace: true });
    } catch (loginError) {
      setError(loginError.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <Navigation />
      <section
        className="admin-login__card"
        aria-labelledby="garage-login-title"
      >
        <div className="admin-login__form-panel">
          <div className="admin-login__content">
            <div>
              <div className="flex items-center justify-center">
                <img src={logo} alt="My Car Kenya Logo" className="w-24 " />
              </div>
            </div>

            <p className="admin-login__eyebrow text-center">Welcome back</p>
            <p className="admin-login__intro text-center">
              Sign in with your garage code to manage bookings, jobs and
              invoices.
            </p>

            <form onSubmit={handleSubmit} className="admin-login__form">
              <label>
                Garage code
                <input
                  autoComplete="username"
                  value={code}
                  onChange={(event) => setCode(event.target.value)}
                  required
                  autoFocus
                />
              </label>
              <label>
                Password
                <input
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                />
              </label>
              {error && (
                <p className="admin-login__error" role="alert">
                  {error}
                </p>
              )}
              <button type="submit" className="themed" disabled={isSubmitting}>
                {isSubmitting ? "Signing in..." : "Sign in"}
              </button>
            </form>
          </div>

          <p className="admin-login__footer">
            Registered garages only — cregister with My Car <a href="https://garage.mycarapp.co.ke#get-started" className="text-blue-400">here</a> to get a garage code
          </p>
        </div>
      </section>
    </main>
  );
}
